import { useLayoutEffect } from 'react'
import { useGetCompanyData } from './useGetCompanyData'

export const useSetTitle = (loaded: boolean) => {
  const { companyName } = useGetCompanyData()

  useLayoutEffect(() => {
    document.title = companyName
    if (__PLATFORM__ !== 'desktop') {
      document.body.style.overflow = 'hidden'
    }
    if (__PLATFORM__ === 'titan') {
      document.body.style.pointerEvents = 'none'
    }
  }, [loaded])
}
